module.exports = __webpack_public_path__ + "media/images/LOGO_W-a070d99c5d167d68edfd5fe4b910bb0b.png";